{
    "version": null,
    "buildNumber": "N/A",
    "git":     {
      "repository": "git@git.molaris.local:dths/dths-frontend.git",
      "branch": "origin/develop",
      "sha1": "01f479da1579e81fad351e99a8c891cba519f4d4",
      "date": null
    }
  }
